export interface Plugin {
  slug: string;
  name: string;
  type: PLUGINS;
  config: PluginConfigReadSpeaker | PluginConfigStellia;
  metaData: PluginMetadataStellia;
}

export interface PluginConfigStellia {
  url: string;
  apiKey: string;
}

export interface PluginMetadataStellia {
  externalIdentifier: string;
}

export interface PluginConfigReadSpeaker {
  url: string;
  clientId: number;
}

export enum PLUGINS {
  STELLIA = 'stellia',
  READ_SPEAKER = 'readSpeaker',
}
